import { MAP_TYPES } from '@deck.gl/carto';

const CUSTOMSQL_FOURTH_SOURCE_ID = 'customSqlFourthSource';

const source = {
  id: CUSTOMSQL_FOURTH_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: undefined,
  data: undefined,
};

export default source;
